import { type MutationHookOptions, useMutation } from "@apollo/client";
import { CreatePlatformCustomCoverMutation } from "../graphql/mutations";
import type {
  CreatePlatformCustomCoverMutationType,
  CreatePlatformCustomCoverMutationVariablesType,
} from "@/types/graphql/partner.generated";

export const useCreatePlatformCustomCoverMutation = (
  options?: MutationHookOptions<
    CreatePlatformCustomCoverMutationType,
    CreatePlatformCustomCoverMutationVariablesType
  >
) => {
  return useMutation<
    CreatePlatformCustomCoverMutationType,
    CreatePlatformCustomCoverMutationVariablesType
  >(CreatePlatformCustomCoverMutation, options);
};
